import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { PlayerConsentDTO, UpdatePlayerConsentDTO } from './player-consents.model';

@Injectable({
  providedIn: 'root',
})
export class PlayerConsentsService {
  constructor(private http: HttpClient) {}

  public update(playerId: number, dto: UpdatePlayerConsentDTO): Observable<void> {
    return this.http.put<void>(`/player/api/backoffice/players/${playerId}/consents`, dto);
  }

  public updateV2(playerId: number, dto: UpdatePlayerConsentDTO): Observable<void> {
    return this.http.put<void>(`/player/api/backoffice/players/${playerId}/consents/v2`, dto);
  }

  public get(playerId: number): Observable<PlayerConsentDTO> {
    return this.http.get<PlayerConsentDTO>(`/player/api/backoffice/players/${playerId}/consents`);
  }
}
